import { NodeProps } from 'reactflow';
import { BranchConditionNodeData } from 'assets/js/pages/engage/workflows/actions/types';
import * as CanvasNode from 'assets/js/pages/engage/workflows/components/CanvasNode';
import { twMerge } from 'tailwind-merge';

interface BranchConditionProps extends NodeProps<BranchConditionNodeData> {}
const BranchCondition = ({ id, data: { formData } }: BranchConditionProps) => {
    const conditionValue = formData?.values.value;

    return (
        <CanvasNode.Root isSelected={false} isError={false} id={id}>
            <CanvasNode.Container className="min-w-0 border-0 md:min-w-0">
                <CanvasNode.Body className="p-0">
                    <div
                        className={twMerge(
                            'rounded-md border px-3 py-2 text-sm font-medium leading-none',
                            conditionValue
                                ? 'border-green-600 bg-green-50 text-green-600'
                                : 'border-red-600 bg-red-50 text-red-600',
                        )}
                    >
                        {conditionValue ? 'Yes' : 'No'}
                    </div>
                </CanvasNode.Body>
            </CanvasNode.Container>
        </CanvasNode.Root>
    );
};

export { BranchCondition };
